import { WSAlert } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { queriesInternalAccounts, queriesTaxWithholdings } from "@query";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { selectorActiveTaxWithholdingAccount } from "../../../shared/selectors/selectorActiveTaxWithholdingAccount";
import { PATH_TAX_WITHHOLDINGS } from "../paths";

export const AlertTaxWithholdingsEnabled: React.FC = () => {
  const history = useHistory();

  const querySettings =
    queriesTaxWithholdings.getTaxWithholdingSettings.useQuery();
  const internalAccounts =
    queriesInternalAccounts.listInternalAccounts.useQuery();
  const queryFeatureFlags = useFeatureFlags();

  const showTaxWithholdingAlert = useMemo(() => {
    if (
      !queryFeatureFlags.data ||
      !queryFeatureFlags.data.taxWithholdingInvoicingAlerts
    ) {
      return false;
    }

    const activeTaxWithholdingsAccount = internalAccounts.data?.data?.find(
      selectorActiveTaxWithholdingAccount
    );

    if (!activeTaxWithholdingsAccount) {
      return false;
    }

    return querySettings.data?.isEnabled === true;
  }, [
    internalAccounts.data,
    queryFeatureFlags.data,
    querySettings.data?.isEnabled
  ]);

  if (!showTaxWithholdingAlert) {
    return null;
  }

  return (
    <WSAlert
      theme="success"
      icon="check-circle"
      title="You’re actively preparing for taxes"
      action={{
        text: "View tax withholdings",
        onClick: () => {
          history.push(PATH_TAX_WITHHOLDINGS);
        }
      }}
    >
      You're setting aside withholdings from your earnings — a smart step that
      helps you stay financially prepared for taxes.
    </WSAlert>
  );
};
